import { GetServerSideProps } from 'next';
import { api } from 'services/apiClient';
import PoolPage from 'templates/pool';
import { Pool } from 'templates/pool/types';

export default ({ pool }: { pool: Pool }) => {
  return <PoolPage data={pool} isGuest={true} />;
};
export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
  const { slug } = ctx.params;
  const { data: pool } = await api.get(`pools/${slug}`);

  const mappedPool = {
    ...pool,
    active: pool.status !== 'finished'
  };

  return {
    props: {
      pool: mappedPool,
    },
  };
};
